<template>
  <div>
    <div class="ib-testimonial-bg ib-default-flex">
      <div class="my-5 text-center container">
        <div class="row">
          <div class="col-md-6 offset-md-3 text-center">
            <h2 class="ib-section-title pt-1 pt-sm-2 wow animate__animated animate__fadeInRight">
              <span>Our</span> User Review
            </h2>
            <p style="margin-bottom:0;" class="ib-heading-desc wow animate__animated animate__fadeInLeft">What Our Customers think about us</p>
          </div>
        </div>

        <div class="row d-flex align-items-center mt-md-3">
          <div class="col-12">
            <div id="demo" class="carousel slide" data-ride="carousel">
              <!-- The slideshow -->
              <div class="container carousel-inner no-padding">
                <div class="carousel-item active">
                  <img class="img-fluid" alt="rewards icon" :src="require('@/assets/images/male-avatar.svg')" />
                  <h3 class="customer-title">Jahangir N.</h3>
                  <h6 class="customer-user">Customer</h6>
                    <p class="user-quote">The seamless experience of the website is a plus.</p>
                </div>
                <div class="carousel-item">
                  <img class="img-fluid" alt="rewards icon" :src="require('@/assets/images/male-avatar.svg')" />
                  <h3 class="customer-title">Umer C.</h3>
                  <h6 class="customer-user">Customer</h6>
                    <p class="user-quote">Best insurance platform ever</p>
                </div>
                <div class="carousel-item">
                  <img class="img-fluid" alt="rewards icon" :src="require('@/assets/images/male-avatar.svg')" />
                  <h3 class="customer-title">Salman H.</h3>
                  <h6 class="customer-user">Customer</h6>
                    <p class="user-quote">Excellent service.</p>
                </div>
              </div>

              <!-- Indicators -->
              <ul class="carousel-indicators">
                <li data-target="#demo" data-slide-to="0" class="active"></li>
                <li data-target="#demo" data-slide-to="1"></li>
                <li data-target="#demo" data-slide-to="2"></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TestimonialCarousel',
    data () {
      return {
      }
    },
    components: {
    },
    created () {
    },
    methods: {
    }
  }
</script>

<style scoped>
  .col-md-3 {
    display: inline-block;
    margin-left:-4px;
  }
  .col-md-3 img {
    width:100%;
    height:auto;
  }
  body .carousel-indicators li {
    background-color:var(--secondary-color) !important;
  }
  body .carousel-control-prev-icon,
  body .carousel-control-next-icon {
    background-color:red;
  }
  body .no-padding {
    padding-left: 0;
    padding-right: 0;
  }
  .carousel-indicators .active {
    opacity: 1 !important;
    height: 8px;
    width: 55px;
    border-radius: 13px;
    border-top: 5px;
    border-bottom: 5px;
  }
  .carousel-indicators li {
    width: 18px;
    height: 8px;
    border-radius: 13px;
    border-top: 5px;
    border-bottom: 5px;
    box-shadow: 0 3px 4px 0px rgba(114, 81, 61, 0.31);
  }
  @media(max-width:550px) {
    .carousel-item img {
    width: 130px;
    margin-top: 30px;
    }
    .user-quote {
      margin: 20px 0px 50px !important;
    }
  }
  .container.carousel-inner.no-padding {
    min-height: 21rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/TestimonialCarousel.vue